import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const CROP_VARIETY_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CROP_VARIETY,
  false // No tenant ID in the base URL
);

export const cropVarietyItemApi = {
  cropItemVarietyForm: () => apiClient.get(`${CROP_VARIETY_BASE}/form`),

  editCropVarietyItemForm: Id =>
    apiClient.get(
      `${CROP_VARIETY_BASE}/form?is_edit=true&crop_variety_id=${Id}`
    ),

  createCropVarietyItem: combinedData =>
    apiClient.post(`${CROP_VARIETY_BASE}`, combinedData),

  updateCropVarietyItem: (crop_id, combinedData) =>
    apiClient.put(`${CROP_VARIETY_BASE}/${crop_id}`, combinedData),

  updateCropVarietyItemStatus: (crop_id, isActive) =>
    apiClient.post(
      `${CROP_VARIETY_BASE}/status?id=${crop_id}&isActive=${isActive}`
    )
};
